function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M38.7837 30.6V16.2C38.7837 15.3513 38.4469 14.5374 37.8476 13.9373C37.2482 13.3371 36.4354 13 35.5877 13H16.4123C15.5646 13 14.7518 13.3371 14.1524 13.9373C13.5531 14.5374 13.2163 15.3513 13.2163 16.2V30.6M38.7837 30.6H13.2163M38.7837 30.6L40.829 34.68C40.9522 34.9247 41.0106 35.1971 40.9984 35.4709C40.9863 35.7448 40.9041 36.0109 40.7597 36.2438C40.6154 36.4767 40.4137 36.6685 40.174 36.8009C39.9343 36.9333 39.6646 37.0019 39.3909 37H12.6091C12.3354 37.0019 12.0657 36.9333 11.826 36.8009C11.5863 36.6685 11.3846 36.4767 11.2403 36.2438C11.0959 36.0109 11.0137 35.7448 11.0016 35.4709C10.9894 35.1971 11.0478 34.9247 11.171 34.68L13.2163 30.6",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 25.5,
  cy: 25.5,
  r: 24.5,
  stroke: "black",
  strokeWidth: 2
});

var SvgFeatureIcon3 = function SvgFeatureIcon3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeatureIcon3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/featureIcon3.08dfd160.svg";
export { ForwardRef as ReactComponent };